export const destinationOverwrite: Record<string, string> = {
  'le_678c61ac5b4f91ca86e112fc50e63766': 'le_3b1b1222c9e8e9afa9d1ee10d6e80fc0', // Sydney ->Sydney CBD
  'le_15fa44474c92da27cf2125373356db4c': 'le_32530ba0f5faff63a2f1ccb9c1bc90fc', // Melbourne ->Melbourne CBD
  'le_7c27cf9f8fe09724bb754e474610eb0e': 'le_187c3fb00828eae7f44b0e0b2b6f1877', // Perth ->Perth CBD
  'le_b96d145f6c31e35755f4a6841574ba37': 'le_7dd5d0e1dbd8aed668ed1d6a2e402846', // Brisbane ->Brisbane CBD
  'le_f4c2c73d7fe5eb38fd83d32a61604247': 'le_17f97623431f2025902d7f0fef1b70b1', // Adelaide ->Adelaide CBD
  'le_b573c52d599a979ba8c16e9789bb8014': 'le_9c9c4718960bd8d37d674c923df91eeb', // Hobart -> Hobart CBD
  'le_5f169380fd43eadac8a9f1423aaa9ac8': 'le_629cd97c7d72a1d7e85909c24d66fe5f', // Canberra -> Canberra CBD
  'le_3f08f0e6992e8d712984a799e6681209': 'le_0a7184747218c4cb31e983ab19d01dab', // Darwin ->Darwin CBD
  'le_66ff0e7c30438d414ff0a941b759f114': 'le_8150c8232c40a27facde91222e859ead', // London -> London CBD
  'le_bd4c9ab730f5513206b999ec0d90d1fb': 'le_bf6a141b7ea02381cfade57101113e70', // Singapore -> Singapore CBD
}

export const outBoundOverwrite: Record<string, App.OfferListBounds> = {
  'le_bac732346917b0a1231354ef55faf00a': {
    southwest: {
      lat: -28.058795,
      lng: 153.390229,
    },
    northeast: {
      lat: -27.975524,
      lng: 153.439668,
    },
  }, // Gold Coast
}
